import {WritableSignal} from '@angular/core';
import {ValidationType} from '@core/api/data-access';
import {ISignCycle} from '@global-data';
import {uuidv4} from '@shared-types';

import {ValidationModel} from '../models';
import {IBaseValidationTest, IDocumentVerificationTest, IFaceMatchValidatorTest, ILivenessValidatorTest} from '../schemas';

export function livenessValidatorTestFactory(validationModel: ValidationModel, signCycleModel$: WritableSignal<ISignCycle>): IBaseValidationTest {
	const schema = validationModel.toJSON();
	const type = schema.type;

	const test: IBaseValidationTest = {
		uid: uuidv4(),
		schema,
		results: {
			passed: false,
			resultData: null,
			details: {
				passingDate: null,
				completed: false,
			},
		},
		inputData: null,
		as<T extends IBaseValidationTest>(): T {
			return this;
		},
		isValid(): boolean {
			return this.results.passed === true;
		},
	};

	// Specific validation test adaptations:
	switch (type) {
		case ValidationType.Liveness:
			const livenessTest = test.as<ILivenessValidatorTest>();
			livenessTest.isValid = () => Boolean(livenessTest?.results?.resultData?.imageData);
			return livenessTest;
		case ValidationType.DocumentVerification:
			const documentVerificationTest = test.as<IDocumentVerificationTest>();
			// check if the document verification test has a meta-tag value to compare:
			const metaTagKey = documentVerificationTest?.schema?.valueToCompareSource?.metaTag;
			if (metaTagKey) {
				//	get the meta-tag value from the sign cycle model:
				const metaTagValue = signCycleModel$ && signCycleModel$()?.metaTags.find(metaTag => metaTag.metaTag === metaTagKey);
				if (metaTagValue) {
					documentVerificationTest.inputData = {
						...documentVerificationTest.inputData,
						cycleMetaTag: metaTagValue,
					};
				}
			}
			documentVerificationTest.isValid = () => Boolean(documentVerificationTest.results.resultData.imageData);
			return documentVerificationTest;
		case ValidationType.FaceMatch:
			const faceMatchTest = test.as<IFaceMatchValidatorTest>();
			faceMatchTest.isValid = () => Boolean(faceMatchTest.results.resultData?.imageData);
			return faceMatchTest;
		case ValidationType.Regex:
			return test;
		default:
			throw new Error(`Validation type ${type} is not supported`);
	}
}
